import { createFileRoute } from "@tanstack/react-router";
import Screenshots from "@/pages/Screenshots";

export const Route = createFileRoute("/screenshots")({
  head: () => ({
    meta: [
      { title: "Screenshots — De Hussel App" },
      { name: "description", content: "Interne demo-pagina met live screenshots." },
      { property: "og:title", content: "Screenshots — De Hussel App" },
      { property: "og:description", content: "Interne demo-pagina met live screenshots." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/screenshots" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/screenshots" }],
  }),
  component: Screenshots,
});
